var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.bankDetails, function(bankDetail, index) {
        return _c("div", { key: index, staticClass: "row gutter-sm" }, [
          _c(
            "div",
            { class: [_vm.bankDetailsNotEmpty ? "col-11" : "col-12"] },
            [
              _c("bank-details-input", {
                attrs: {
                  value: bankDetail,
                  id: index,
                  expanded: _vm.bankDetailsNotEmpty,
                  label: _vm.label,
                  hideLabel: _vm.hideLabel,
                  showIcon: _vm.showIcon
                },
                on: {
                  input: function($event) {
                    _vm.updateBankDetails($event, index)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.bankDetailsNotEmpty,
                  expression: "bankDetailsNotEmpty"
                }
              ],
              staticClass: "col-1 text-right"
            },
            [
              _c("q-btn", {
                staticClass: "q-mt-lg",
                attrs: {
                  flat: "",
                  dense: "",
                  icon: "remove_circle",
                  color: "light"
                },
                on: {
                  click: function($event) {
                    _vm.clearBankDetails(index)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c("q-btn", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.bankDetailsNotEmpty,
                expression: "bankDetailsNotEmpty"
              }
            ],
            class: _vm.showControls ? "q-mr-xl" : "",
            attrs: {
              flat: "",
              dense: "",
              label: _vm.$t("additional_bank_details")
            },
            on: { click: _vm.addBankDetails }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }